/**
 * RFC-113 §1.3 — LOD crossfade via 3d-tiles-renderer TilesFadePlugin.
 * Opt-in via VITE_PLATEAU_LOD_FADE=true until validated on Tokyo scene.
 */
import { TilesFadePlugin } from '3d-tiles-renderer/plugins';
import { PLATEAU_FEATURES } from './plateauFeatures';

const FADE_DURATION_MS = 400;
const registeredTiles = new WeakSet<object>();

export function maybeRegisterPlateauLodFade(entity: unknown): boolean {
  if (!PLATEAU_FEATURES.lodFade) return false;

  const tiles = (entity as { tiles?: { registerPlugin?: (p: unknown) => void } })?.tiles;
  if (!tiles?.registerPlugin || registeredTiles.has(tiles as object)) return false;

  tiles.registerPlugin(
    new TilesFadePlugin({
      fadeDuration: FADE_DURATION_MS,
      fadeRootTiles: false,
    }),
  );
  registeredTiles.add(tiles as object);
  console.log(`[Giro3DAdapter] TilesFadePlugin registered (duration=${FADE_DURATION_MS}ms)`);
  return true;
}
